module.exports = __webpack_public_path__ + "static/logo-50d2074c9e850a6e3832a630e461ed3b.png";